<template>
	<section id="OrderHistory">
		<div id="account-banner">
			<img src="../../../assets/img/Hero-banner.png" alt="">
		</div>

        <div id="searchOptions">
            <div class="container">
                <h1>Search for Orders</h1>
                <div class="row">
                    <div class="col-lg-3 mb-4 mb-lg-0">
                        <label for="orderStatus">View By Order Status</label>
                        <div class="ui fluid search selection dropdown" id="orderstatus">
                            <input type="hidden" name="orderStatus" v-model="orderStatus" id="orderStatus" @change="onStatusChange"/>
                            <div class="default text">Select Order Status</div>
                            <i class="dropdown icon"></i>
                            <div class="menu">
                                <div class="item" value="All">All</div>
                                <div class="item" value="Pending">Pending</div>
                                <div class="item" value="Sent">Sent</div>
                                <div class="item" value="RFQ">Quote</div>
                                <div class="item" value="Released">Released</div>
                                <div class="item" value="Fully Shipped">Fully Shipped</div>
                                <div class="item" value="Hold">Hold</div>
                                <div class="item" value="Cancelled">Cancelled</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 mb-4 mb-lg-0" v-if="currentUser.admin">
                        <label for="userSelect">Select User</label>
                        <div class="ui fluid search selection dropdown" id="userSelection">
                            <input type="hidden" name="userSelect" v-model="userSelect" id="userSelect" @change="onUserChange"/>
                            <div class="default text">Select User</div>
                            <i class="dropdown icon"></i>
                            <div class="menu">
                                
                                 <div class="item" v-for="user in users" :key="user.value" v-bind:data-value="user.value">
                                    {{user.text}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2 mb-4 mb-lg-0">
                        <label for="">&nbsp;</label>
                        <a class="btn btn-primary" @click="searchOrders">Go</a>
                    </div>
                </div>
            </div>
        </div>

        <div id="acctOrders">
            <div class="container">
                <div id="ao-table">
                    <div class="row" v-if="!orders">
                        <div class="col-12 mt-4"><h3>You have no current orders.</h3></div>
                    </div>

                    <b-table 
                    id="ordersTable"
                        :per-page="perPage"
                        :current-page="currentPage" 
                        stacked="lg" 
                        :fields="fields" 
                        :items="orders" 
                        responsive="sm" 
                    v-else>

                        <template v-slot:cell(orderId)="data">
                            {{data.item.id}}
                        </template>
                        
                        <!--<template v-slot:cell(jcOrderId)="data">
                            {{data.item.jcOrderId}}
                        </template> -->

                        <template v-slot:cell(status)="data">
                            {{data.item.status}}
                        </template>

                        <template v-slot:cell(purchaseOrderNumber)="data">
                             <div v-for="po in data.item.purchaseOrders" :key="po.number">
                            {{po.purchaseOrderNumber}},
                            </div>
                        </template>

                        <template v-slot:cell(date)="data">
                            {{data.item.dateCreated | formatDate}}
                        </template>

                        <!-- <template v-slot:cell(promisedShipDate)="data">
                            {{data.item.promisedShipDate}}
                        </template>

                        <template v-slot:cell(lastShippedDate)="data">
                            {{data.item.lastShippedDate}}
                        </template> -->

                        <template v-slot:cell(options)="data">
                            <a class="btn btn-dark" @click="viewOrder(data.item.id)">Review</a>
                        </template>
                    </b-table>
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="ordersTable"
                        ></b-pagination>
                   
                   <div class="table-notice">*Please note that pricing is subject to change on re-orders.</div>
                </div>
            </div>
        </div>

        <div id="searchRFQs">
            <div class="container">
                <h1>Search for Quotes</h1>
                <div class="row">
                    <div class="col-lg-3 mb-4 mb-lg-0">
                        <label for="orderStatusRFQ">View By Order Status</label>
                        <div class="ui fluid search selection dropdown" id="orderstatusRFQ">
                            <input type="hidden" name="orderStatus" v-model="orderStatusRFQ" id="orderStatusRFQ" @change="onStatusChangeRFQ"/>
                            <div class="default text">Select Order Status</div>
                            <i class="dropdown icon"></i>
                            <div class="menu">
                                <div class="item" value="All">All</div>
                                <div class="item" value="Pending">Pending</div>
                                <div class="item" value="Sent">Sent</div>
                                <div class="item" value="RFQ">Quote</div>
                                <div class="item" value="Released">Released</div>
                                <div class="item" value="Fully Shipped">Fully Shipped</div>
                                <div class="item" value="Hold">Hold</div>
                                <div class="item" value="Cancelled">Cancelled</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 mb-4 mb-lg-0" v-if="currentUser.admin">
                        <label for="userSelectRFQ">Select User</label>
                        <div class="ui fluid search selection dropdown" id="userSelectionRFQ">
                            <input type="hidden" name="userSelect" v-model="userSelectRFQ" id="userSelectRFQ" @change="onUserChangeRFQ"/>
                            <div class="default text">Select User</div>
                            <i class="dropdown icon"></i>
                            <div class="menu">
                                
                                 <div class="item" v-for="user in users" :key="user.value" v-bind:data-value="user.value">
                                    {{user.text}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2 mb-4 mb-lg-0">
                        <label for="">&nbsp;</label>
                        <a class="btn btn-primary" @click="searchRFQs">Go</a>
                    </div>
                </div>
            </div>
        </div>

        <div id="acctQuotes">
            <div class="container">
                <div id="ao-table">
                    <div class="row">
                        <div class="col-lg-5">
                            <a class="btn btn-primary" @click="deleteQuotes">Delete All Selected Quotations</a>
                        </div>
                    </div>

                    <div class="row" v-if="!rfqs">
                        <div class="col-12 mt-4"><h3>You have no current quotes.</h3></div>
                    </div>

                    <b-table 
                    id="rfqTable"
                        :per-page="perPageRFQ"
                        :current-page="currentPageRFQ" 
                        stacked="lg" 
                        :fields="rfqfields" 
                        :items="rfqs" 
                        selectable 
                        select-mode="multi"
                        responsive="sm" 
                        @row-selected="onRowSelected" 
                    v-else>
                        <template v-slot:cell(selected)="{ rowSelected }">
                             <template v-if="rowSelected">
                                <span aria-hidden="true">&check;</span>
                                <span class="sr-only">Selected</span>
                            </template>
                            <template v-else>
                                <span aria-hidden="true">&nbsp;</span>
                                <span class="sr-only">Not selected</span>
                            </template>
                        </template>

                        <template v-slot:cell(orderId)="data">
                            {{data.item.id}}
                        </template>

                        <!-- <template v-slot:cell(jcOrderId)="data">
                            {{data.item.jcOrderId}}
                        </template> -->

                        <template v-slot:cell(purchaseOrderNumber)="data">
                            <div v-for="po in data.item.purchaseOrders" :key="po.number">
                            {{po.number}}
                            </div>
                        </template>

                        <template v-slot:cell(date)="data">
                            {{data.item.dateCreated | formatDate}}
                        </template>

                        <!-- <template v-slot:cell(promisedShipDate)="data">
                            {{data.item.promisedShipDate}}
                        </template>

                        <template v-slot:cell(lastShippedDate)="data">
                            {{data.item.lastShippedDate}}
                        </template> -->

                        <template v-slot:cell(options)="data">
                            <div class="nav-item dropdown">
                                <a
                                    class="nav-link dropdown-toggle"
                                    data-toggle="dropdown"
                                    href="#"
                                    role="button"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                    ><span>Select an Option</span></a
                                >
                              
                                <div class="dropdown-menu">
                                    <a class="dropdown-item table-item" @click="viewQuote(data.item.id)">Review</a>
                                    <a class="dropdown-item table-item" @click="createOrder(data.item.id)">Create Order</a>
                                </div>
                            </div>
                        </template>
                    </b-table>
                    <b-pagination
                        v-model="currentPageRFQ"
                        :total-rows="rowsRFQ"
                        :per-page="perPageRFQ"
                        aria-controls="rfqTable"
                        ></b-pagination>
                   
                   <div class="table-notice">*Please note that pricing is subject to change on re-orders.</div>
                </div>
            </div>
        </div>
	</section>
</template>

<script>
import { mapGetters } from "vuex";
import { recordSearch } from "@/assets/js/activity";
import FeApiService from "@/assets/js/FeApiService";
const apiService = new FeApiService();

import Vue from "vue";
import Vue2Filters from "vue2-filters";

Vue.use(Vue2Filters);

import 'semantic-ui-dropdown/dropdown.js';
export default {
    name: "SearchOrders",
    computed: {
        ...mapGetters({ currentUser: "currentUser" })
    },
    mounted() {
        $('.ui.dropdown').dropdown();
        this.getUsers();
        // this.searchOrders();
    },
    data() {
        return {
            currentPage: 1,
            perPage: 10,
            currentPageRFQ: 1,
            perPageRFQ: 10,
            rows: "",
            rowsRFQ: "",
            x: [],
            rowSelected: false,
            orderStatus: "",
            users: [],
            userSelect: "",
            orderStatusRFQ: "",
            userSelectRFQ: "",
            sortBy: 'dateCreated|desc',
            orders: [],
            fields: [
                // 'selected',
                {key: 'orderId', label: 'Order #'},
                // {key: 'jcOrderId', label: 'JC Steele Order #'},
                {key: 'status', label: 'Status'},
                {key: 'purchaseOrderNumber', label: 'PO #'},
                {key: 'date', label: 'Date'},
                // {key: 'promisedShipDate', label: 'Promised Ship Date'},
                // {key: 'lastShippedDate', label: 'Last Shipped Date'},
                {key: 'options', label: ''},
            ],
            rfqs: [],
            rfqfields: [
                'selected',
                {key: 'orderId', label: 'Order #'},
                // {key: 'jcOrderId', label: 'JC Steele Order #'},
                {key: 'purchaseOrderNumber', label: 'PO #'},
                {key: 'date', label: 'Date'},
                // {key: 'promisedShipDate', label: 'Promised Ship Date'},
                // {key: 'lastShippedDate', label: 'Last Shipped Date'},
                {key: 'options', label: 'Options'},
            ],
            selected: []
        };
    },
    methods: {
        onRowSelected(items) {
            this.selected = items
        },
        deleteQuotes() {
            this.selected.forEach(item => {
                apiService
                    .deleteQuote({
                        id: item.id
                    })
                    .then()
                    .catch(err => this.deleteFailed(err));
            });
        },
        deleteFailed(err) {
            this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
                title: err.error.response.data.title,
                autoHideDelay: 10000,
                appendToast: false,
                variant: "danger",
                solid: true
            });
        },
        searchOrders() {
                // Activity trail: the "Search Orders" page Go button.
                recordSearch("order-search", this.orderStatus);
                apiService
                    .searchOrders({
                        status: this.orderStatus,
                        user: this.userSelect
                    })
                    .then(request => {
                            this.ordersSuccessful(request);
                        })
                    .catch(err => this.ordersFailed(err));
        },
        ordersSuccessful(request) {
            this.rows = request.total;
            this.currentPage = request.current_page;
            // this.perPage = request.per_page;
            this.orders = Array.from(request.data[0]);
        },
        ordersFailed(err) {
            this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
                title: err.error.response.data.title,
                autoHideDelay: 10000,
                appendToast: false,
                variant: "danger",
                solid: true
            });
        },
        searchRFQs() {
                apiService
                    .searchRFQs({
                        status: this.orderStatusRFQ,
                        user: this.userSelectRFQ
                    })
                    .then(request => {
                            this.RFQsSuccessful(request);
                        })
                    .catch(err => this.RFQsFailed(err));
        },
        RFQsSuccessful(request) {
            this.rowsRFQ = request.total;
            this.currentPageRFQ = request.current_page;
            // this.perPageRFQ = request.per_page;
            this.rfqs = Array.from(request.data);
        },
        RFQFailed(err) {
            this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
                title: err.error.response.data.title,
                autoHideDelay: 10000,
                appendToast: false,
                variant: "danger",
                solid: true
            });
        },
        getUsers() {
            apiService
                .getUsers()
                .then(data => {
                    this.users = data;
            });
        },
        viewOrder(id) {
            this.$router.push({
                    name: "Order Details",
                    params: {
                        id: id,
                    }
                });
        },
        viewQuote(id) {
            this.$router.push({
                    name: "RFQ Details",
                    params: {
                        id: id,
                    }
                });
        },
        createOrder(id){
            apiService
                .rfqOrder({
                    id: id
                })
                .then(request => {
                        this.orderSuccessful(request);
                    })
                .catch(err => this.orderFailed(err));
        },
        orderSuccessful(request) {
            localStorage.cartId = request.id;
            this.$router.push({
                    name: "Cart",
                    params: {
                        id: request.id,
                    }
                });
        },
        orderFailed(err) {
            this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
                title: err.error.response.data.title,
                autoHideDelay: 10000,
                appendToast: false,
                variant: "danger",
                solid: true
            });
        },
        onStatusChange(event) {
            this.orderStatus = event.target.value;
        },
        onUserChange(event) {
            this.userSelect = event.target.value;
        },
        onStatusChangeRFQ(event) {
            this.orderStatusRFQ = event.target.value;
        },
        onUserChangeRFQ(event) {
            this.userSelectRFQ = event.target.value;
        },
    }
};
</script>
